import { Box, Typography } from "@mui/material"
import { formatAuthorNoteDate, sanitizePdfHtml } from "./pdf-formatters"

export function PdfAuthorNote({ note }) {
    const safeContent = sanitizePdfHtml(note?.content)

    if (!safeContent) return null

    return (
        <Box
            sx={{
                bgcolor: "#ebecef",
                borderRadius: "8px",
                p: "12px 14px",
                mt: "10px",
                pageBreakInside: "avoid",
                breakInside: "avoid",
            }}
        >
            <Typography sx={{ fontWeight: 700, fontSize: "10px", color: "#1f2937", mb: "8px" }}>Author Note</Typography>
            <Box
                className="styled-bullets"
                sx={{
                    fontSize: "10px",
                    lineHeight: 1.5,
                    color: "#374151",
                    "& p": { m: 0, mb: "4px" },
                    "& ul, & ol": { my: "4px", pl: "18px" },
                    "& li": { mb: "2px" },
                    "& table": { width: "100%" },
                    "& img": { maxWidth: "100%" },
                }}
                dangerouslySetInnerHTML={{ __html: safeContent }}
            />
            <Typography sx={{ fontSize: "9px", color: "#7b8794", mt: "10px" }}>
                {formatAuthorNoteDate(note.date)}
            </Typography>
        </Box>
    )
}
